<h2 mat-dialog-title>{{ 'release-notes.dialog.title' | translate }}</h2>
<mat-dialog-content>{{ 'release-notes.dialog.message' | translate }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'release-notes.dialog.cancel' | translate }}</button>
    <button mat-flat-button color="primary" (click)="goToReleaseNotes()">
        {{ 'release-notes.dialog.go-to-notes' | translate }}
    </button>
</mat-dialog-actions>
